// Core reusable logic extracted from SkuProductSelect

// Merge initial selected ids with available items (put initially selected first, keep uniqueness)
export function mergeInitialAndAvailable(initialSelected = [], availableItems = []) {
  const selectedSet = new Set(initialSelected);
  const merged = [...initialSelected];
  for (const id of availableItems) {
    if (!selectedSet.has(id)) {
      merged.push(id);
      selectedSet.add(id);
    }
  }
  return merged;
}

// Map id -> product for O(1) access
export function buildProductByIdMap(keywordGroups) {
  if (!keywordGroups) return new Map();
  return new Map(keywordGroups.map((p) => [p.id, p]));
}

// Convert API product to UI product shape
export function toProductDisplay(product, selectedIds) {
  if (!product) return null;
  const isSelected = selectedIds.has(product.id);
  return {
    id: product.id,
    title: product.name,
    image: product.image_url || "/assets/images/placeholder.jpg",
    keyword: product.keywords,
    selected: isSelected,
    sku: product.keywords?.[0] || "-",
  };
}

export function buildProductsDataList(
  combinedItems = [],
  productById = new Map(),
  selectedIds = new Set()
) {
  return combinedItems
    .map((productId) => toProductDisplay(productById.get(productId), selectedIds))
    .filter(Boolean);
}

export function buildSelectedProductsData(
  selectedIdsArray = [],
  productById = new Map()
) {
  return (selectedIdsArray || [])
    .map((id) => {
      const p = productById.get(id);
      if (!p) return null;
      return {
        id: p.id,
        title: p.name,
        image: p.image_url || "/assets/images/placeholder.jpg",
        keyword: p.keywords,
        selected: true,
        sku: p.keywords?.[0] || "-",
      };
    })
    .filter(Boolean);
}

export function areAllSelected(productsDataList = [], selectedProductsData = []) {
  return (
    productsDataList.length > 0 &&
    selectedProductsData.length === productsDataList.length
  );
}

export function toggleSelection(currentIds = [], productId) {
  if (currentIds?.includes(productId)) {
    return currentIds.filter((id) => id !== productId);
  }
  return [...(currentIds || []), productId];
}

export function computeSelectAllIds(productsDataList = []) {
  return productsDataList.map((p) => p.id);
}

export function formatBrandOptions(apiData) {
  if (!apiData) return [];
  const list = Array.isArray(apiData.listKeywordGroups)
    ? apiData.listKeywordGroups
    : [];
  return list
    .map((option) => ({ id: option.id, displayText: option.name }))
    .filter((option) => option.displayText !== "Not Applicable");
}
